export const FailedIcon = ({
  width = 100,
  height = 100,
  fill = "#ff4444",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M54.074 63.7036C54.074 61.658 52.4158 60 50.3704 60C48.3249 60 46.6667 61.658 46.6667 63.7036C46.6667 65.7491 48.3249 67.4073 50.3704 67.4073C52.4158 67.4073 54.074 65.7491 54.074 63.7036Z"
        fill={fill}
      />
      <path
        d="M50.3704 20C49.388 20 48.446 20.3902 47.7515 21.0848C47.0569 21.7794 46.6667 22.7214 46.6667 23.7037V53.3334C46.6667 54.3157 47.0569 55.2577 47.7515 55.9523C48.446 56.6468 49.388 57.037 50.3704 57.037C51.3527 57.037 52.2947 56.6468 52.9893 55.9523C53.6838 55.2577 54.074 54.3157 54.074 53.3334V23.7037C54.074 22.7214 53.6838 21.7794 52.9893 21.0848C52.2947 20.3902 51.3527 20 50.3704 20Z"
        fill={fill}
      />
      <path
        d="M53.4641 10L86.3731 67C87.9127 69.6667 85.9882 73 82.909 73H17.091C14.0118 73 12.0873 69.6667 13.6269 67L46.5359 10C48.0755 7.33333 51.9245 7.33333 53.4641 10Z"
        stroke={fill}
        strokeWidth="4"
      />
    </svg>
  );
};

export const WarningIcon = ({
  width = 100,
  height = 100,
  fill = "#f2b705ff",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M54.074 63.7036C54.074 61.658 52.4158 60 50.3704 60C48.3249 60 46.6667 61.658 46.6667 63.7036C46.6667 65.7491 48.3249 67.4073 50.3704 67.4073C52.4158 67.4073 54.074 65.7491 54.074 63.7036Z"
        fill={fill}
      />
      <path
        d="M50.3704 20C49.388 20 48.446 20.3902 47.7515 21.0848C47.0569 21.7794 46.6667 22.7214 46.6667 23.7037V53.3334C46.6667 54.3157 47.0569 55.2577 47.7515 55.9523C48.446 56.6468 49.388 57.037 50.3704 57.037C51.3527 57.037 52.2947 56.6468 52.9893 55.9523C53.6838 55.2577 54.074 54.3157 54.074 53.3334V23.7037C54.074 22.7214 53.6838 21.7794 52.9893 21.0848C52.2947 20.3902 51.3527 20 50.3704 20Z"
        fill={fill}
      />
      <path
        d="M53.4641 10L86.3731 67C87.9127 69.6667 85.9882 73 82.909 73H17.091C14.0118 73 12.0873 69.6667 13.6269 67L46.5359 10C48.0755 7.33333 51.9245 7.33333 53.4641 10Z"
        stroke={fill}
        strokeWidth="4"
      />
    </svg>
  );
};

export const DoneIcon = ({
  width = 40,
  height = 40,
  fill = "#58b957",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <g>
          <g>
            <path
              d="M27.7003 10.3499C27.5278 10.2133 27.3299 10.1123 27.1181 10.0525C26.9063 9.99282 26.6848 9.97563 26.4663 10.002C26.2478 10.0283 26.0367 10.0977 25.8452 10.206C25.6536 10.3144 25.4854 10.4596 25.3503 10.6333L13.6836 25.6333L7.96698 18.6666C7.83289 18.4881 7.66431 18.3384 7.47123 18.2263C7.27816 18.1142 7.06454 18.042 6.84304 18.0141C6.62155 17.9862 6.3967 18.003 6.18184 18.0636C5.96698 18.1242 5.76649 18.2274 5.59227 18.367C5.41805 18.5066 5.27365 18.6798 5.16764 18.8763C5.06164 19.0728 4.99618 19.2885 4.97517 19.5108C4.95416 19.733 4.97801 19.9573 5.04532 20.1701C5.11263 20.383 5.22201 20.5802 5.36698 20.7499L12.317 29.3833C12.4738 29.5766 12.672 29.7324 12.897 29.8391C13.122 29.9458 13.368 30.0008 13.617 29.9999C13.8813 30.0117 14.1446 29.9605 14.3851 29.8503C14.6257 29.7402 14.8366 29.5744 15.0003 29.3666L28.0503 12.6999C28.1834 12.5233 28.2799 12.322 28.3344 12.1077C28.3889 11.8933 28.4001 11.6703 28.3676 11.4516C28.335 11.2329 28.2592 11.0229 28.1447 10.8337C28.0301 10.6446 27.8791 10.4801 27.7003 10.3499Z"
              fill={fill}
            />
            <path
              d="M36.0337 10.3499C35.8612 10.2133 35.6633 10.1123 35.4515 10.0525C35.2397 9.99282 35.0182 9.97563 34.7997 10.002C34.5812 10.0283 34.3701 10.0977 34.1786 10.206C33.987 10.3144 33.8188 10.4596 33.6837 10.6333L22.0171 25.6333L21.0004 24.3833L18.9004 27.0833L20.7337 29.3666C20.8906 29.56 21.0888 29.7157 21.3137 29.8224C21.5387 29.9292 21.7847 29.9841 22.0337 29.9833C22.2841 29.9821 22.5309 29.9246 22.756 29.8149C22.981 29.7053 23.1785 29.5464 23.3337 29.3499L36.3837 12.6833C36.5142 12.5072 36.6086 12.3071 36.6616 12.0944C36.7146 11.8818 36.7252 11.6607 36.6927 11.444C36.6602 11.2273 36.5852 11.0191 36.4722 10.8313C36.3591 10.6436 36.2101 10.48 36.0337 10.3499Z"
              fill={fill}
            />
            <path
              d="M14.5167 21.7666L16.6667 19.0666L16.3334 18.6666C16.2018 18.4843 16.0347 18.3305 15.8421 18.2144C15.6495 18.0984 15.4355 18.0225 15.2128 17.9914C14.9902 17.9603 14.7635 17.9745 14.5465 18.0332C14.3295 18.092 14.1266 18.194 13.95 18.3332C13.7788 18.4708 13.6365 18.6408 13.5312 18.8335C13.4259 19.0262 13.3597 19.2379 13.3365 19.4563C13.3133 19.6746 13.3334 19.8955 13.3958 20.106C13.4582 20.3166 13.5616 20.5128 13.7 20.6832L14.5167 21.7666Z"
              fill={fill}
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
